(function () {
  'use strict';

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.DB = window.DB || {};
  window.DB.reducedMotion = mq.matches;

  mq.addEventListener('change', function (e) {
    window.DB.reducedMotion = e.matches;
  });

  if (window.DB.reducedMotion) return;

  var io;

  function getIO() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('db-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });
    return io;
  }

  function observeAll() {
    document.querySelectorAll('[data-db-reveal]:not(.db-in)').forEach(function (el) {
      getIO().observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-scan when the theme editor injects a new section
  document.addEventListener('shopify:section:load', observeAll);
})();
